export const penColors = {black: "#161616", red: "#c62828", green: "#17803d", blue: "#155ac4"} as const;
export type PhotoStroke = {tool: "pen" | "eraser"; color: keyof typeof penColors; width: number; points: {x: number; y: number}[]};
export type PhotoAnnotation = {strokes: PhotoStroke[]; updatedAt: string};
export function validPhotoStrokes(value: unknown): value is PhotoStroke[] {
  if (!Array.isArray(value) || value.length > 500) return false;
  let count = 0;
  return value.every(s => s && ["pen", "eraser"].includes(s.tool) && Object.hasOwn(penColors, s.color) &&
    Number.isFinite(s.width) && s.width >= .001 && s.width <= .1 && Array.isArray(s.points) && s.points.length > 0 &&
    (count += s.points.length) <= 50000 && s.points.every((p: {x: number; y: number}) => p &&
      Number.isFinite(p.x) && Number.isFinite(p.y) && p.x >= 0 && p.x <= 1 && p.y >= 0 && p.y <= 1));
}
// Draw only on the transparent annotation layer: erasing never alters the photo.
export function drawPhotoStrokes(canvas: HTMLCanvasElement, strokes: PhotoStroke[]) {
  const ctx = canvas.getContext("2d");
  if (!ctx) return;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  for (const s of strokes) {
    ctx.globalCompositeOperation = s.tool === "eraser" ? "destination-out" : "source-over";
    ctx.strokeStyle = ctx.fillStyle = penColors[s.color];
    ctx.lineWidth = s.width * canvas.width;
    ctx.lineCap = ctx.lineJoin = "round";
    const first = s.points[0];
    if (!first) continue;
    if (s.points.length === 1) {
      ctx.beginPath(); ctx.arc(first.x * canvas.width, first.y * canvas.height, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill();
    } else {
      ctx.beginPath(); ctx.moveTo(first.x * canvas.width, first.y * canvas.height);
      for (const p of s.points.slice(1)) ctx.lineTo(p.x * canvas.width, p.y * canvas.height);
      ctx.stroke();
    }
  }
  ctx.globalCompositeOperation = "source-over";
}
